import AppMaintenancePage from './AppMaintenancePage';

export default AppMaintenancePage;
